import { Alert } from "flowbite-react";

export default function NotFoundPage({ message }: { message: string }) {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-white px-4">
      <div className="text-center mb-6">
        <h1 className="text-4xl font-extrabold text-blue-900 mb-2">
          404 - Not Found
        </h1>
        <p className="text-lg text-blue-700">Something went wrong.</p>
      </div>
      
      <a
        href="/"
        className="mt-6 inline-block bg-blue-900 hover:bg-blue-800 text-white px-5 py-2 rounded-lg transition duration-150"
      >
        Go Back Home
      </a>
    </div>
  );
}
